<template>
  <div id="app">
    <div class ="sel">
      <vSelect placeholder = 'Select game...' v-model="selected" :options="options"></vSelect>
    </div>
    <div class="wrapper">
      <vuepgn v-bind="{pgn:pgn,height}"></vuepgn>
    </div>
  </div>
</template>

<script>
import { vuepgn } from "vue-pgn";
import vSelect from "vue-select";
// import 'vue-pgn/dist/vue-pgn.css'

const games = [
  {
    id: 0,
    label: "Ding Liren - Oliver Barbosa 2012",
    pgn: `[Event "Chess Olympiad"]
    [Site "Istanbul TUR"]
    [Date "2012.09.06"]
    [EventDate "2012.08.28"]
    [Round "9.2"]
    [Result "1-0"]
    [White "Ding Liren"]
    [Black "Oliver Barbosa"]
    [ECO "D16"]
    [WhiteElo "2695"]
    [BlackElo "2554"]
    [PlyCount "51"]

    1. d4 d5 2. c4 c6 3. Nf3 Nf6 4. Nc3 dxc4 5. a4 e6 6. e4 Bb4
    7. e5 Nd5 8. Bd2 a5 9. Bxc4 Be7 10. h4 h6 11. h5 Na6 12. Ne4
    Nab4 13. Rh3 b6 14. Rg3 Bf8 15. Kf1 Qd7 16. Qe2 Bb7 17. Nd6+
    Bxd6 18. exd6 Qxd6 19. Ne5 Rg8 20. Bxh6 f6 21. Bxg7 fxe5
    22. h6 O-O-O 23. h7 Rxg7 24. Rxg7 exd4 25. Rg8 Qh2 26. h8=Q
    1-0`
  },
  {
    id: 1,
    label: "Anand - Kramnik 2008",
    pgn: `[Event "Anand - Kramnik World Championship Match"]
    [Site "Bonn GER"]
    [Date "2008.10.20"]
    [EventDate "2008.10.14"]
    [Round "5"]
    [Result "0-1"]
    [White "Vladimir Kramnik"]
    [Black "Viswanathan Anand"]
    [ECO "D49"]
    [WhiteElo "?"]
    [BlackElo "?"]
    [PlyCount "70"]

    1.d4 d5 2.c4 c6 3.Nf3 Nf6 4.Nc3 e6 5.e3 Nbd7 6.Bd3 dxc4 7.Bxc4
    b5 8.Bd3 a6 9.e4 c5 10.e5 cxd4 11.Nxb5 axb5 12.exf6 gxf6
    13.O-O Qb6 14.Qe2 Bb7 15.Bxb5 Rg8 16.Bf4 Bd6 17.Bg3 f5 18.Rfc1
    f4 19.Bh4 Be7 20.a4 Bxh4 21.Nxh4 Ke7 22.Ra3 Rac8 23.Rxc8 Rxc8
    24.Ra1 Qc5 25.Qg4 Qe5 26.Nf3 Qf6 27.Re1 Rc5 28.b4 Rc3 29.Nxd4
    Qxd4 30.Rd1 Nf6 31.Rxd4 Nxg4 32.Rd7+ Kf6 33.Rxb7 Rc1+ 34.Bf1
    Ne3 35.fxe3 fxe3 0-1`
  },
  {
    id: 2,
    label: "Sjugirov - Kveinys 2017",
    pgn: `[Event "European Individual Chess Championship"]
    [Site "Minsk BLR"]
    [Date "2017.06.07"]
    [EventDate "2017.05.30"]
    [Round "8.57"]
    [Result "1-0"]
    [White "Sanan Sjugirov"]
    [Black "Aloyzas Kveinys"]
    [ECO "C95"]
    [WhiteElo "2654"]
    [BlackElo "2520"]
    [PlyCount "163"]

    1. e4 e5 2. Nf3 Nc6 3. Bb5 a6 4. Ba4 Nf6 5. O-O Be7 6. Re1 b5
    7. Bb3 d6 8. c3 O-O 9. h3 Nb8 10. d4 Nbd7 11. Nbd2 Bb7 12. Bc2
    Re8 13. Nf1 Bf8 14. Ng3 g6 15. Bg5 h6 16. Bd2 Bg7 17. a4 exd4
    18. cxd4 c5 19. Qc1 Kh7 20. d5 Nb6 21. b3 b4 22. a5 Nc8
    23. Bf4 Nd7 24. Ra2 Qc7 25. Nf1 Na7 26. Ne3 Nb5 27. Nc4 Rad8
    28. Bd3 Nf6 29. Rae2 Nh5 30. Bh2 Bc3 31. Rf1 Qe7 32. g4 Nf6
    33. Bg3 Nd7 34. Kh2 Kg7 35. Bf4 Rh8 36. Rg1 Qf6 37. Bxh6+ Rxh6
    38. Qxh6+ Kxh6 39. g5+ Kg7 40. gxf6+ Nxf6 41. Nb6 Rh8 42. Re3
    Nh5 43. Rg4 Nf6 44. Rg1 Nh5 45. Bc4 Nf4 46. h4 Nd4 47. Rg4 Nh5
    48. Kh3 Nxf3 49. Rxf3 Nf6 50. Rxf6 Kxf6 51. f4 Ke7 52. f5 Rh6
    53. Bd3 Be5 54. Kg2 Bf6 55. Kg3 Kd8 56. fxg6 Be5+ 57. Kf3 fxg6
    58. Nc4 Bh2 59. Rg2 Rxh4 60. Rxg6 Kc7 61. Rg7+ Kb8 62. Rg8+
    Kc7 63. Rg7+ Kb8 64. Bf1 Rh6 65. Rg8+ Kc7 66. Rg7+ Kb8 67. Nb6
    Rh8 68. Nd7+ Ka8 69. Bc4 Rh4 70. Rg8+ Ka7 71. Nb8 Rh7 72. Nc6+
    Bxc6 73. dxc6 Rc7 74. Bd5 Be5 75. Rd8 Bh2 76. Kg4 Be5 77. Kf5
    Bh2 78. Ke6 Bg3 79. Rxd6 Bxd6 80. Kxd6 Kb8 81. e5 Kc8 82. Be6+
    1-0`
  }
];

export default {
  components: { vuepgn: vuepgn, vSelect },
  data() {
    return {
      selected: null,
      options: [],
      // pgn: '',
      height: 300
    };
  },
  computed: {
    // геттер вычисляемого значения
    pgn: function() {
      if (this.selected === null) return '';
      return this.selected.pgn
    }
  },
  props: {
    msg: String
  },
  mounted() {
    this.options = games;
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  width: 50%;
  margin: 0 auto;
  margin-top: 60px;
}



.wrapper {
  width: 600px;
  border: 1px solid;
  border-color: #f3f3f3;
  margin-top: 60px;
}

.sel {
  width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue